let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("g7uLf")).then(() => parcelRequire('6Ctkw'));